module.exports = __webpack_public_path__ + "static/media/promo2.4c8f5ef7.jpg";